import { IState } from './types'

const isInputLoading = (state: IState) => (namespace: string, inputId: string): boolean => {
  return state.loadingInputs.includes(`${namespace}_${inputId}`)
}

const loadingInputs = (state: IState) => state

export default {
  isInputLoading,
  loadingInputs,
}
